import React from "react";

/**
 * DB Computronics official logo mark (from company-supplied artwork).
 * The PNG is a tight-cropped square with the brand's own grey backing.
 * `size` controls the height in pixels; width scales 1:1.
 */
export default function LogoMark({ size = 36, className = "", withWordmark = true, wordmarkClassName = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/brand/logo.png"
        alt="DB Computronics"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-md object-contain shadow-[0_4px_14px_-4px_rgba(0,0,0,0.35)]"
        loading="eager"
        decoding="async"
      />
      {withWordmark && (
        <span className={`font-display tracking-tight leading-none ${wordmarkClassName}`}>
          Computronics<span className="text-[#A4161A]">.</span>
        </span>
      )}
    </span>
  );
}
